import {
    GET_HEALTH_REPORT_DATA,
    SUCCESS_FEATURE_IMAGE,
    LOADING_FEATURE_IMAGE,
    FEATURE_IMAGE
} from '../actions/reportAction';

const initialState = {
    historyData: [],
    featureImageLoading: false,
    featureImage: '',
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_FEATURE_IMAGE:
            return {
                ...state,
                featureImageLoading: action.payload
            };
        case GET_HEALTH_REPORT_DATA:
        return {
            ...state,
            historyData: action.payload
        };
        case SUCCESS_FEATURE_IMAGE:
            return {
                ...state,
                featureImageLoading: false,
                featureImage: action.payload,
            };

        case FEATURE_IMAGE:
            return {
                ...state,
                featureImageLoading: false,
                featureImage: action.payload.body,
            };


        default:
            return {
                ...state
            };
    }
}
